import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AdsPlacementService } from 'src/app/classes/ads-placement.service';
import { Assignment } from 'src/app/classes/assignment';
import { Organization } from 'src/app/classes/organization';
import AdsPlacementStatuses from 'src/app/constants/ads-placement-statuses';
import { AdsCampaignService } from 'src/app/services/ads-campaign.service';

@Component({
  selector: 'app-placements',
  templateUrl: './placements.component.html',
  styleUrls: ['./placements.component.css']
})
export class PlacementsComponent {
  
  adsPlacementStatuses = AdsPlacementStatuses;

  assignments: Assignment[] = [];
  organizations: Organization[] = [];

  form = new FormGroup({
    organization: new FormControl<number|string>('all'),
    status: new FormControl('all'),
    assignment: new FormControl<string|null>(null),
    text: new FormControl(''),
    r: new FormControl(Math.floor(Math.random() * 999999)),
  });
  
  constructor(
    private router: Router,
    private adsPlacementService: AdsPlacementService,
    private adsCampaignService: AdsCampaignService
  ) {}

  ngOnInit(): void {
    this.adsCampaignService.organizations().subscribe(organizations => {
      this.organizations = organizations;
    });

    this.adsPlacementService.assignments().subscribe(assignments => {
      this.assignments = assignments
    });
  }

  search() {
    this.form.controls.r.setValue(Math.floor(Math.random() * 999999));
    this.router.navigate(['placements', 'search'], { queryParams: this.form.value });
  }
}
